import { getLanguage } from '@/lang/index'

const state = {
  language: getLanguage(),
}

const mutations = {

}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
